function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
import React from "react";
import PropTypes from "prop-types";
import { jsx as ___EmotionJSX } from "@emotion/core";
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "13o7eu2",
  styles: "display:block;"
} : {
  name: "13o7eu2",
  styles: "display:block;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9pY29ucy9zaGllbGQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTU0iLCJmaWxlIjoiLi4vLi4vLi4vc3JjL2ljb25zL3NoaWVsZC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcblxuZnVuY3Rpb24gU2hpZWxkKHsgc2l6ZSwgcHJpbWFyeUNvbG9yLCB0ZXN0SWQgfSkge1xuICByZXR1cm4gKFxuICAgIDxzdmdcbiAgICAgIGNzcz17e1xuICAgICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICB9fVxuICAgICAgd2lkdGg9e3NpemV9XG4gICAgICBoZWlnaHQ9e3NpemV9XG4gICAgICB2aWV3Qm94PVwiMCAwIDMyIDMyXCJcbiAgICAgIGZvY3VzYWJsZT1cImZhbHNlXCJcbiAgICAgIHJvbGU9XCJpbWdcIlxuICAgICAgYXJpYS1sYWJlbD1cIlNoaWVsZFwiXG4gICAgICBkYXRhLXRlc3RpZD17dGVzdElkfVxuICAgID5cbiAgICAgIDxwYXRoXG4gICAgICAgIGQ9XCJNMjUuOTk5IDguMDI3YTIgMiAwIDAwLTIuMjU1LTEuOTgyIDkuNDM5IDkuNDM5IDAgMDEtNi41NzYtMS42NjggMiAyIDAgMDAtMi4zMzYgMCA5LjQxNiA5LjQxNiAwIDAxLTYuNTc4IDEuNjY4IDEuOTY3IDEuOTY3IDAgMDAtMS41NzUuNDgyQTEuOTk2IDEuOTk2IDAgMDA2IDguMDI3djYuNDNjMCA4LjA2NiA3LjA0NSAxMS43NDggOS4yMDQgMTIuNjg0YTEuOTg5IDEuOTg5IDAgMDAxLjU5MiAwQzE4Ljk1NSAyNi4yMDcgMjYgMjIuNTI0IDI2IDE0LjQ1OWwtLjAwMS02LjQzelwiXG4gICAgICAgIGZpbGw9e3ByaW1hcnlDb2xvcn1cbiAgICAgIC8+XG4gICAgPC9zdmc+XG4gICk7XG59XG5cblNoaWVsZC5wcm9wVHlwZXMgPSB7XG4gIHNpemU6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgcHJpbWFyeUNvbG9yOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHRlc3RJZDogUHJvcFR5cGVzLnN0cmluZyxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IFNoaWVsZDtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
function Shield(_ref) {
  var size = _ref.size,
    primaryColor = _ref.primaryColor,
    testId = _ref.testId;
  return ___EmotionJSX("svg", {
    css: _ref2,
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    focusable: "false",
    role: "img",
    "aria-label": "Shield",
    "data-testid": testId
  }, ___EmotionJSX("path", {
    d: "M25.999 8.027a2 2 0 00-2.255-1.982 9.439 9.439 0 01-6.576-1.668 2 2 0 00-2.336 0 9.416 9.416 0 01-6.578 1.668 1.967 1.967 0 00-1.575.482A1.996 1.996 0 006 8.027v6.43c0 8.066 7.045 11.748 9.204 12.684a1.989 1.989 0 001.592 0C18.955 26.207 26 22.524 26 14.459l-.001-6.43z",
    fill: primaryColor
  }));
}
Shield.propTypes = {
  size: PropTypes.string.isRequired,
  primaryColor: PropTypes.string.isRequired,
  testId: PropTypes.string
};
export default Shield;